<template>
  <!-- Table Template      **************************** -->
  <div id="primer-content" v-if="slide.img.length" v-show="slide.template == 'table'">
    <h1 style="text-align: center">{{ slide.pageTitle }}</h1>

    <div class="lessoncard">
      <p
        class="margin-top"
        id="text"
        style="font-size: 16pt !important"
        v-if="slide.textArea && slide.displayMode !== 'richText'"
      >
        {{ slide.textArea }}
      </p>
      <p
        class="margin-top"
        id="text"
        style="font-size: 16pt !important"
        v-if="slide.bodyText && slide.displayMode !== 'imageDeck'"
        v-html="slide.bodyText"
      ></p>
      <div
        v-if="
          (slide.displayMode === 'both' || slide.displayMode === 'imageDeck') &&
          slide.img
        "
      >
        <div class="row rowsize" v-for="(image, i) in slide.img" :key="i">
          <div class="column">
            <div v-bind:class="{ 'loading': !isLoaded }">
              <v-img
                v-show="isLoaded"
                @load="onImgLoad"
                :src="
                  $store.state.primerImages.find((o) => o.name === image.file)
                    .url
                "
              />
            </div>
          </div>
          <div class="column">
            <h2
              v-if="slide.caption"
              class="imagetext"
              id="caption"
              style="font-size: 18pt !important; font-weight: 800 !important"
            >
              {{ slide.caption[i] }}
            </h2>
          </div>
        </div>
      </div>
      <div
        v-if="
          (slide.displayMode === 'both' || slide.displayMode === 'richText') &&
          slide.richText
        "
      >
        <div class="row rowsize" v-for="(entry, j) in slide.richText" :key="j">
          <div class="column">
            <div v-bind:class="{ 'loading': !isLoaded }">
              <v-img
                v-show="isLoaded"
                v-if="entry.image"
                @load="onImgLoad"
                :src="getImageSrc(entry.image[0])"
              />
            </div>
          </div>
          <div class="column">
            <span
              v-show="entry.richText"
              id="caption"
              v-html="entry.richText"
              style="font-size: 18pt !important; font-weight: 800 !important"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <image-modal
      :showModal="showModal"
      :card="activeCard"
      :modalImage="clickedImg"
      v-on:close-modal="closeModal()"
    ></image-modal>
  </div>
</template>

<script>
import ImageModal from "./ImageModal.vue";
export default {
  components: { "image-modal": ImageModal },
  props: ["slide"],
  data() {
    return {
      isLoaded: false,
      clickedImg: "",
    };
  },
  mounted(){
    const paragraphs = document.getElementById('primer-content');
    var links = paragraphs.getElementsByTagName("a");
    for (var i=0; i<links.length; i++){
      links[i].setAttribute('target', '_blank');
    }
  },
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    imgClick(item) {
      if(this.isMobile() == false){
        item.showModal = true;
        this.clickedImg = this.getImageSrc(item.image[0]);
        this.activeCard.fullBody = item.richText
        this.openModal();
      } else return
    },
    getImageSrc(img) {
      if (img && this.slide.img.length) {
        return this.$store.state.primerImages.find(
          (o) => o.name === this.slide.img.find((x) => x.id === img).file
        ).url;
      }
    },
    onImgLoad() {
      this.isLoaded = true;
    },
    openModal(index) {
      this.showModal = true;
      console.log("show modal");
    },
    closeModal() {
      this.showModal = false;
      console.log("close modal");
    },
  },
};
</script>
<style scoped>
#text >>> *{
  font-size: 16pt !important;
}
#caption {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
@media screen and (min-width: 1000px){
  #caption >>> * {
    font-size: 2vw !important;
    font-weight: 700;
  }
  .rowsize{
    width: 50%;
    margin: auto;
  }  
}

@media screen and (min-width: 600px) and (max-width: 1000px) {
  #caption >>> * {
    font-size: 2.5vw !important;
    font-weight: 700;
  }
  .rowsize{
    width: 70%;
    margin: auto;
  }   
}
@media screen and (max-width: 600px) {
  #caption >>> * {
    font-size: 4vw !important;
    font-weight: 700;
  }
  .rowsize{
  width: 100%;
  margin: auto;
  }
}
h1 {
  text-align: center;
  color: #415370;
}
h4 {
  text-align: center;
  vertical-align: middle;
}
.lessoncard {
  max-width: 80%;
  margin: auto;
  font-size: 16pt !important;
}
.caption {
  color: #776c6c;
  padding-left: 10px;
}

.column{
  width: 50%;
}
.row{
  display: flex;
  gap: 50px;
  margin-bottom: 50px;
}

.loading {
  height: 150px;
  width: 150px;
  margin: auto;
  background: transparent
    url("https://miro.medium.com/max/882/1*9EBHIOzhE1XfMYoKz1JcsQ.gif") center
    no-repeat;
}

.margin-top {
  margin-top: 50px;
}
</style>
